import { useContext } from 'react';
import { TourContext } from './tour-context';

export function useTour() {
  const value = useContext(TourContext);
  if (!value) throw new Error('useTour deve essere usato dentro TourProvider.');
  return value;
}
